import { render, staticRenderFns } from "./BillingTicketTab.vue?vue&type=template&id=31906bfa&"
import script from "./BillingTicketTab.vue?vue&type=script&lang=js&"
export * from "./BillingTicketTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports